import create from "zustand";
const STORE = {
  currentAppId: "",
  context: {
    pageId: ""
  },
  //Default values for variables,
  appVariablesDef: {},
  appVariables: {},
  storeInstances: {}
};

export const useBaseAppDevStore = create((setState, getState) => ({
  ...STORE,
  updatecurrentAppId: (appId) => {
    setState((state) => ({
      currentAppId: appId
    }));
  },
  updateStaticVariable: (variables) => {
    setState((state) => ({
      appVariablesDef: variables
    }));
  },
  resetState: () => {
    setState(() => ({
      currentAppId: "",
      appVariablesDef: {}
    }));
  },
  getVariable: (key) => {
    let value = getState().appVariables[key];
    if (value !== undefined || value !== null) {
      return value;
    } else {
      const appId = getState().currentAppId;
      let oldVariableStore = sessionStorage.getItem(appId)
        ? JSON.parse(sessionStorage.getItem(appId))
        : {};
      return oldVariableStore[key] ?? "";
    }
  },
  setVariable: (key, value) => {
    let newVariables = { ...getState().appVariables };
    newVariables[key] = value;
    sessionStorage.setItem(
      getState().currentAppId,
      JSON.stringify(newVariables)
    );
    setState((state) => ({
      appVariables: newVariables
    }));
    return {
      [key]: value
    };
  },
  updateVariables: (object) => {
    let newVariables = { ...getState().appVariables, ...object };
    sessionStorage.setItem(
      getState().currentAppId,
      JSON.stringify(newVariables)
    );
    setState((state) => ({
      appVariables: newVariables
    }));
    return object;
  },
  setAppContext: ({ appId, pageId, currentRole }) => {
    setState((state) => ({
      currentAppId: appId,
      context: {
        appId,
        pageId,
        currentRole
      }
    }));
  },
  updateCurrentPage: (pageId) => {
    setState((state) => ({
      context: {
        ...getState().context,
        pageId
      }
    }));
  },
  syncVariables: (appId, defaultValues) => {
    let oldVariableStore = sessionStorage.getItem(appId)
      ? JSON.parse(sessionStorage.getItem(appId))
      : {};
    setState((state) => ({
      appVariables: { ...defaultValues, ...oldVariableStore },
      currentAppId: appId
    }));
  },
  getWorkerInstance: (workerInstanceId) => {
    return getState().storeInstances?.[workerInstanceId];
  },
  setWorkerInstance: (workerInstanceId, workerInstance) => {
    setState((state) => ({
      storeInstances: {
        ...getState().storeInstances,
        [workerInstanceId]: workerInstance
      }
    }));
  }
}));
